import { User } from '@types'
import { client } from './client'

const clubService = async (userId: string, cocap: string, date: string): Promise<User[]> => {
  const { data } = await client.get(`/person/club/tree?id=${userId}&date=${date}`, {
    headers: {
      cocap
    }
  })
  if (data) return data as User[]
  return []
}

const clubServiceList = async (userId: string, cocap: string) => {
  const { data } = await client.get(`/person/map/${userId}`, {
    headers: {
      cocap
    }
  })
  return data
}

const findMemberService = async (userId: string, cocap: string, name: string): Promise<User | null> => {
  const { data } = await client.get(`/person/club/member?club=${userId}&name=${name}`, {
    headers: {
      cocap
    }
  })
  if (data) return data as User
  return null
}

export { clubService, findMemberService, clubServiceList }
